// 1. Vendor Type Identifiers
const VENDOR_TYPE = {
    SUPPLIER: 'supplier',
    CONTRACTOR: 'contractor',
    SUB_CONTRACTOR: 'sub-contractor',
}

// 2. Vendor Type Display Labels
const VENDOR_TYPE_LABEL = {
    SUPPLIER: 'Supplier',
    CONTRACTOR: 'Contractor',
    SUPPLIERS: 'Suppliers',
    CONTRACTORS: 'Contractors',
}

// 3. Vendor Import Types
const VENDOR_IMPORT_TYPE = {
    SUPPLIERS: 'import-suppliers',
    CONTRACTORS: 'import-contractors',
    SUPPLIER: 'Supplier',
    SUB_CONTRACTOR: 'sub-contractor',
}

// 4. Tab/Navigation Values
const VENDOR_TAB = {
    SUPPLIERS: 'suppliers',
    CONTRACTORS: 'contractors',
    PURCHASE_ORDERS: 'purchase-orders',
    WORK_ORDERS: 'work-orders',
    SUPPLIER_INVOICES: 'supplier-invoices',
    CONTRACTOR_INVOICES: 'contractor-invoices',
}

// 5. URL Parameters
const VENDOR_URL_PARAM = {
    TAB: 'tab',
    SUB_TAB: 'subTab',
    RETURN_TAB: 'returnTab',
    RETURN_SUB_TAB: 'returnSubTab',
    PO_ID: 'poId',
}

// 6. Status Values
const VENDOR_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
}

const INVOICE_STATUS_TAB = {
    ACTIVE: 'active',
    POSTED: 'posted',
}

const SYNC_BILLS_BUTTON = {
    SYNC_SUPPLIER_BILLS: "SYNC SUPPLIER BILLS",
    SYNC_CONTRACTOR_BILLS: "SYNC CONTRACTOR BILLS",
    SYNC_BILLS: "SYNC BILLS"
}

// Legacy aliases for backward compatibility during migration
const VENDORTYPE = VENDOR_TYPE
const VENDOR_TYPE_NAME = VENDOR_TYPE_LABEL
const VENDOR_RETURN_TAB = { ...VENDOR_TAB, TAB: 'tab', SUB_TAB: 'subTab' }
const VENDOR_SEARCH_PARAMS = VENDOR_URL_PARAM
const VENDOR_DEFAULT_SUB_TAB = VENDOR_STATUS
const VENDOR_INVOICE_TYPE = VENDOR_TYPE

export {
    VENDOR_TYPE,
    VENDOR_TYPE_LABEL,
    VENDOR_IMPORT_TYPE,
    VENDOR_TAB,
    VENDOR_URL_PARAM,
    VENDOR_STATUS,
    INVOICE_STATUS_TAB,
    // Legacy exports for backward compatibility
    VENDORTYPE,
    VENDOR_TYPE_NAME,
    VENDOR_RETURN_TAB,
    VENDOR_SEARCH_PARAMS,
    VENDOR_DEFAULT_SUB_TAB,
    VENDOR_INVOICE_TYPE,
    SYNC_BILLS_BUTTON
}